import { Accordion, AccordionDetails, AccordionSummary, createStyles, Theme, Typography, withStyles, WithStyles } from '@material-ui/core';
import React from 'react';
import { Days, Positions } from './tablemodels';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PositionAccordion from './PositionAccordion';

interface DepartmentAccordionProps {
    department: String,
    positions: Positions,
}

const styles = ({ typography }: Theme) => createStyles({
    heading: {
      fontSize: typography.pxToRem(15),
      fontWeight: typography.fontWeightMedium,
      textTransform: 'uppercase',
    },
    details: {
      display: 'unset',
      padding: 0,
    },
  });

class DepartmentAccordion extends React.Component<DepartmentAccordionProps & WithStyles<typeof styles>> {
    render() {
        const { department, positions, classes } = this.props;

        return (<Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography className={classes.heading}>{department}</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                        { Array.from(positions.entries()).map(([position, days]: [string, Days]) => <PositionAccordion key={position} position={position} days={days} />) }
                    </AccordionDetails>
                </Accordion>);
    }
}

export default withStyles(styles)(DepartmentAccordion);